import classNames from 'classnames';
import styles from './NavigationList.module.scss';
import { UI_Link } from 'ui/components/1-atoms/Action/Link/Link';
import { UI_Icon } from 'ui/components/1-atoms/Media/Icon/Icon';
import UI_Chevron from 'ui/icons/icon-chevron-down.svg';

export interface NavigationItemProps {
	id: string;
	name: string;
	url: string;
	descendants?: Array<NavigationItemProps>;
	current?: boolean;
	active?: boolean;
	hidden?: boolean;
	title?: string;
}
export interface NavigationListProps {
	className?: string;
	id?: string;
	navigationItems?: NavigationItemProps[];
	maxLevels?: number;
	state?: string[];
	navigationLevel?: number;
	clickHandler?: (id: string) => void;
}

export const NavigationList = ({ className, id, navigationItems, navigationLevel = 0, maxLevels, clickHandler, state }: NavigationListProps) => {
	if (!navigationItems) return null;

	const currentLevel = navigationLevel + 1;
	return (
		<ul id={id} className={classNames(styles.NavigationList, styles[`NavigationList___level${currentLevel}`], className)}>
			{navigationItems &&
				navigationItems.map((navigationItem: NavigationItemProps) => {
					return (
						<li
							key={navigationItem.id}
							id={`panel-${navigationItem.id}`}
							aria-labelledby={navigationItem.descendants && currentLevel < maxLevels ? `trigger-${navigationItem.id}` : null}
							className={classNames(styles.NavigationList_item, {
								['isOpen']: state.includes(navigationItem.id),
							})}
						>
							<UI_Link
								ariaCurrent={navigationItem.current === true}
								url={navigationItem.url}
								className={classNames(styles.NavigationList_link, {
									[styles.isActive]: navigationItem.active === true,
									[styles.isCurrent]: navigationItem.current === true,
								})}
							>
								{navigationItem.title || navigationItem.name}
							</UI_Link>
							{navigationItem.descendants && currentLevel < maxLevels && (
								<button
									id={`trigger-${navigationItem.id}`}
									aria-label={navigationItem.title || navigationItem.name}
									aria-expanded={state.includes(navigationItem.id)}
									aria-haspopup="true"
									className={styles.NavigationList_toggle}
									onClick={() => clickHandler(navigationItem.id)}
								>
									<UI_Icon className={styles.NavigationList_toggleIcon} title="Expand" ariaHidden={false} size="sm">
										<UI_Chevron />
									</UI_Icon>
								</button>
							)}
							{currentLevel < maxLevels && (
								<NavigationList
									navigationItems={navigationItem.descendants}
									navigationLevel={currentLevel}
									maxLevels={maxLevels}
									clickHandler={clickHandler}
									state={state}
								/>
							)}
						</li>
					);
				})}
		</ul>
	);
};
